<template>
    <div class="container py-5">
        <div class="row justify-content-between">
            <div class="col-4">
                <h1>Content</h1>
            </div>
        </div>
    </div>
</template>
<script>

</script>
